import { TextField } from '@mui/material';
import "../../assets/style/PayMethod.css";

export default function CreditCardForm(props) {
      const { 
    cardNumber, setCardNumber, 
    cardHolder, setCardHolder, 
    expiryDate, setExpiryDate, 
    cvv, setCvv,
    notes, setNotes
  } = props;
  
  return (
    <div className="payment-form-fields">
     <TextField label="Card Number" variant="outlined" fullWidth className="custom-textfield" value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} />
      <TextField label="Card Holder" variant="outlined" fullWidth className="custom-textfield" value={cardHolder} onChange={(e) => setCardHolder(e.target.value)} />
      <div className="form-row">
        <TextField label="Expiry Date" placeholder="MM/YY" variant="outlined" fullWidth className="custom-textfield" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
        <TextField label="CVV" variant="outlined" fullWidth className="custom-textfield" value={cvv} onChange={(e) => setCvv(e.target.value)} />
      </div>
      <TextField label="Notes" variant="outlined" fullWidth multiline rows={3} className="custom-textfield" value={notes} onChange={(e) => setNotes(e.target.value)} />
    </div>
  );
}